import AgenciaBoletoLicencaService from "@/services/AgenciaBoletoLicencaService";

export const agenciaBoletoLicenca = {
  namespaced: true,
  state: {
    agenciaBoletoLicenca: {},
  },
  actions: {
    getAgenciaBoletoLicenca({ commit }, payload) {
      return AgenciaBoletoLicencaService.GetAgenciaBoletoLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAgenciaBoletoLicenca({ commit }, payload) {
      return AgenciaBoletoLicencaService.PostAgenciaBoletoLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAgenciaBoletoLicenca({ commit }, payload) {
      return AgenciaBoletoLicencaService.PutAgenciaBoletoLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAgenciaBoletoLicenca({ commit }, payload) {
      return AgenciaBoletoLicencaService.DeleteAgenciaBoletoLicenca(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAgenciaBoletoLicencaOData({ commit }, payload) {
      return AgenciaBoletoLicencaService.GetAgenciaBoletoLicencaOData(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default agenciaBoletoLicenca;
